// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"268":"flickity","284":"matter.pkgd","841":"paper-core"}[chunkId] || chunkId) + "." + {"74":"97ca9a8a7d172e7d528c","232":"a19ef99e227d496de779","268":"a7a297a5fd49947dc602","284":"3b6c266aed2213ecf477","551":"76f51ad3d8d8a88b234c","841":"13cd60b275beef1b86c8"}[chunkId] + ".js";
};